import { Button, Checkbox, Form, Input, Select } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import React, { useState } from 'react'
import { unit } from '../../../data/newrentalapplications';
import { Propertiesunitscampaigns } from '../../../data/rentalapplications';
import AttachmentsUpload from '../AttachmentsUpload';
import ConfirmationBox from '../ConfirmationBox';
import MultiSelect from '../MultiSelect';

const text = `Thank you for your interest in our property! To apply, please complete the online application at the link below. Feel free to contact us with any questions or concerns.

Thank You,
 
Integrity Oklahoma LLC
(405) 283-6521
www.Integrityokc.com`;

function EmailRentalApplication({isConfirmationBoxOpen, setIsConfirmationBoxOpen}) {
  const [checked, setChecked] = useState(false);
  return (
    <>
    {isConfirmationBoxOpen ? (
        <ConfirmationBox setIsConfirmationBoxOpen={setIsConfirmationBoxOpen}>
          <h2>Email Rental Application</h2>
          <Form layout="vertical">
            <Form.Item label="Unit or Campaign" required>
              <Select options={unit} placeholder="Search Units and Campaigns" />
            </Form.Item>
            <Form.Item label="Recipients" required>
              <Input placeholder="" />
            </Form.Item>
            <Form.Item label="Bcc">
              <MultiSelect
                options={Propertiesunitscampaigns}
                placeholder="Start typing to search"
              />
            </Form.Item>
            <Form.Item label="First Name" required>
              <Input />
            </Form.Item>
            <Form.Item label="Last Name" required>
              <Input />
            </Form.Item>
            <Form.Item>
              <Checkbox checked={checked} onChange={() => setChecked(!checked)}>
                Send an SMS with a rental application link
              </Checkbox>
            </Form.Item>
            {checked ? (
              <>
                <Form.Item>
                  <p className="silver-text">
                    By checking “Send an SMS with a rental application link”,
                    you acknowledge that you have permission to send SMS
                    messages to the number.
                  </p>
                </Form.Item>
                <Form.Item label="Phone">
                  <Input placeholder="Enter a phone number" />
                </Form.Item>
              </>
            ) : null}
            <Form.Item label="Message" required>
              <TextArea
                placeholder="Enter message"
                rows={8}
                defaultValue={text}
              />
            </Form.Item>
          </Form>
          <p>
            A link to your online rental application will be added
            automatically.
          </p>
          <div className="action-buttons">
            <Button
              type="primary"
              onClick={() => setIsConfirmationBoxOpen(false)}
            >
              Save
            </Button>
            <button
              className="cancel-btn"
              onClick={() => setIsConfirmationBoxOpen(false)}
            >
              Cancel
            </button>
            <span className="onclick-text">Customize My Signature</span>
          </div>
          <div className="attachments">
            {/* <AttachmentsUpload /> */}
          </div>
        </ConfirmationBox>
      ) : null}
    </>
  )
}

export default EmailRentalApplication;
